import { PayloadAction } from "@reduxjs/toolkit";
import { AppState } from "./models/appState";
import { Language } from "./models/language";
import { v4 as uuidv4 } from "uuid";

export const load = (state: AppState) => {
  state.isLoaded = true;
};

export const loadAppContext = (state: AppState) => {
  state.appContext.language = (document.documentElement.lang as Language) || state.appContext.language;
};

export const showConfirmDialog = (state: AppState, action: PayloadAction<any>) => {
  state.modals.push({
    id: uuidv4(),
    type: "ConfirmDialog",
    props: {
      ...action.payload,
    },
  });
};

export const showSlideout = (state: AppState, action: PayloadAction<any>) => {
  state.modals.push({
    id: uuidv4(),
    type: "Slideout",
    props: {
      ...action.payload,
    },
  });
};

export const closeModal = (state: AppState, action: PayloadAction<{ id: string }>) => {
  if (action.payload.id) {
    state.modals = state.modals.filter((modal) => modal.id !== action.payload.id);
  }
};
